import { AxiosInstance } from 'axios';
import ParamService from './paramService';

export default function useParam( axiosIns: AxiosInstance, paramOverrideConfig: Object ) {
  const param = new ParamService( axiosIns, paramOverrideConfig )

  return {
    param,
  }
}